import React from 'react';
import { NamedLink } from '../../components';
import { ensureUser } from '../../util/data';
import css from './CompactHostPreview.module.css';

const CompactHostPreview = ({ listing, reviews = [] }) => {
  if (!listing?.author) return null;

  const author = ensureUser(listing.author);
  const { displayName } = author.attributes?.profile || {};
  const profileImage = author.profileImage;
  const variants = profileImage?.attributes?.variants || {};
  const imgUrl = variants['square-small2x']?.url || variants['square-small']?.url || null;

  const initials = (displayName || '')
    .split(' ')
    .slice(0, 2)
    .map(w => w[0] || '')
    .join('')
    .toUpperCase();

  const avgRating =
    reviews.length > 0
      ? reviews.reduce((sum, r) => sum + (r.attributes?.rating || 0), 0) / reviews.length
      : null;

  if (!author.id) return null;

  const profileParams = { id: author.id.uuid };

  return (
    <div className={css.root}>
      <NamedLink className={css.avatarLink} name="ProfilePage" params={profileParams}>
        <div className={css.avatar}>
          {imgUrl ? (
            <img src={imgUrl} alt={displayName} className={css.avatarImg} />
          ) : (
            <span className={css.avatarInitials}>{initials || '?'}</span>
          )}
        </div>
      </NamedLink>
      <div className={css.info}>
        <NamedLink className={css.nameLink} name="ProfilePage" params={profileParams}>
          {displayName}
        </NamedLink>
        {avgRating !== null ? (
          <span className={css.rating}>
            <span className={css.star}>★</span>
            {avgRating.toFixed(1)}
            <span className={css.reviewCount}>({reviews.length})</span>
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default CompactHostPreview;
